import { useEffect } from "react";
import { useDeepCompare } from "./useDeepCompare";

export const useDeepCompareEffect = (callback: () => void, dependency: unknown, cleanup?: () => void) => {
    const deepEqualDependency = useDeepCompare(dependency);

    useEffect(() => {
        callback();

        return () => {
            if (cleanup) cleanup();
        };
    }, [deepEqualDependency]);
};
